<div class="flex justify-center items-center h-full">
  <div class="w-full max-w-md">
    <p-card>
      <ng-template pTemplate="header">
        <div class="text-center py-4">
          <h2 class="text-2xl font-bold mb-2">{{ 'forgotPassword.title' | translate }}</h2>
          <p class="text-sm">{{ 'forgotPassword.subtitle' | translate }}</p>
        </div>
      </ng-template>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
        <!-- Email Field -->
        <div class="flex flex-col gap-2">
          <label for="email" class="font-medium">{{ 'forgotPassword.email' | translate }}</label>
          <input
            id="email"
            type="email"
            pInputText
            [formControl]="emailControl"
            [placeholder]="'forgotPassword.emailPlaceholder' | translate"
            class="w-full"
          />
          @if (emailControl.invalid && emailControl.touched) {
            <p-message severity="error">
              {{ getEmailErrorMessage() }}
            </p-message>
          }
        </div>

        <!-- Submit Button -->
        <div class="flex flex-col gap-4">
          <p-button
            type="submit"
            [label]="'forgotPassword.sendReset' | translate"
            class="w-full"
            [disabled]="forgotPasswordForm.invalid"
            [loading]="false"
          />

          <!-- Additional Options -->
          <div class="text-center">
            <a routerLink="/login" class="text-sm hover:underline">{{ 'forgotPassword.backToLogin' | translate }}</a>
          </div>
        </div>
      </form>
    </p-card>
  </div>
</div>